// The "Canteen" shortcut stands for every dining place on campus. The API answers `keyword=Canteen`
// with all of these — three Location types plus one point-of-interest type — so the map has to treat
// them as one group when it decides what belongs on `layer_canteens`.
const CanteenTypes = ['Canteen', 'Kitchen', 'UniQue Restaurant', 'Food Booth'];

export default CanteenTypes;
